module.exports = __webpack_public_path__ + "static/img/bg_index_knowmore.b8eabfd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg_index_knowmore.jpg
// module id = P138
// module chunks = 1